import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Print,
  Close,
  Email,
  Phone
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import AnimatedWrapper from "../../components/common/AnimatedWrapper/AnimatedWrapper";
import styles from "./CV.module.scss";
import PropTypes from "prop-types";

const CV = ({ onPageChange }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isPrintMode, setIsPrintMode] = useState(false);

  const handlePrint = () => {
    setIsPrintMode(true);
    window.print();
    setIsPrintMode(false);
  };

  const handleClose = () => {
    if (onPageChange) {
      onPageChange("home");
    } else {
      navigate("/");
    }
  };

  const jobs = t('cv.jobs', { returnObjects: true });
  const skillsList = t('cv.skills_list', { returnObjects: true });

  return (
    <div className={`${styles.cv} ${isPrintMode ? styles.printMode : ""}`}>
      <div className={styles.cv__actions}>
        <button className={styles.cv__printButton} onClick={handlePrint}>
          <Print />
          <span>{t('cv.print')}</span>
        </button>
        <button className={styles.cv__closeButton} onClick={handleClose}>
          <Close />
        </button>
      </div>

      <div className={styles.cv__header}>
        <div className={styles.cv__info}>
          <h1>DARIUSZ SZYMCZAK</h1>
          <div className={styles.cv__contact}>
            <div className={styles.cv__contactItem}>
              <Phone />
              <span>+48 692 683 155</span>
            </div>
            <div className={styles.cv__contactItem}>
              <Email />
              <span>dariuszszymczak.work@gmail.com</span>
            </div>
          </div>
        </div>
        <div className={styles.cv__photo}>
          <img src="/dariusz-army.jpg" alt="Dariusz Szymczak" />
        </div>
      </div>

      <div className={styles.cv__mainContent}>
        <div className={styles.cv__leftColumn}>
          <AnimatedWrapper delay={0.2}>
            <div className={styles.cv__section}>
              <div className={styles.cv__sectionHeader}>
                <h3>{t('cv.experience')}</h3>
                <div className={styles.cv__sectionLine}></div>
              </div>
              <div className={styles.cv__experience}>
                {jobs.map((job, index) => (
                  <div className={styles.cv__job} key={index}>
                    <div className={styles.cv__period}>{job.period}</div>
                    <div className={styles.cv__content}>
                      <h4>{job.company}</h4>
                      <div className={styles.cv__company}>{job.role}</div>
                      <ul>
                        {job.tasks.map((task, taskIndex) => (
                          <li key={taskIndex}>{task}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </AnimatedWrapper>
        </div>

        <div className={styles.cv__rightColumn}>
          <AnimatedWrapper delay={0.4}>
            <div className={styles.cv__section}>
              <div className={styles.cv__sectionHeader}>
                <h3>{t('cv.education')}</h3>
                <div className={styles.cv__sectionLine}></div>
              </div>
              <div className={styles.cv__education}>
                <div className={styles.cv__educationItem}>
                  <div className={styles.cv__period}>2012 - 2016</div>
                  <div className={styles.cv__content}>
                    <h4>{t('cv.school')}</h4>
                    <div className={styles.cv__company}>
                      {t('cv.specialization')}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.cv__section}>
              <div className={styles.cv__sectionHeader}>
                <h3>{t('cv.certificates')}</h3>
                <div className={styles.cv__sectionLine}></div>
              </div>
              <div className={styles.cv__education}>
                <div className={styles.cv__educationItem}>
                  <div className={styles.cv__period}>2025</div>
                  <div className={styles.cv__content}>
                    <b>{t('cv.udt_title')}</b> - {t('cv.udt')}
                  </div>
                </div>
              </div>
            </div>

            <div className={`${styles.cv__section} ${styles.languagesSection}`}>
              <div className={styles.cv__sectionHeader}>
                <h3>{t('cv.languages_title')}</h3>
                <div className={styles.cv__sectionLine}></div>
              </div>
              <ul className={styles.cv__languages}>
                <li>{t('cv.languages.polish')}</li>
                <li>{t('cv.languages.english')}</li>
              </ul>
            </div>

            <div className={styles.cv__section}>
              <div className={styles.cv__sectionHeader}>
                <h3>{t('cv.skills_title')}</h3>
                <div className={styles.cv__sectionLine}></div>
              </div>
              <div className={styles.cv__skills}>
                <div className={styles.cv__skillGroup}>
                  <ul>
                    {skillsList.map((skill, index) => (
                      <li key={index}>{skill}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </AnimatedWrapper>
        </div>
      </div>

      <div className={styles.cv__rodo}>
        {t('cv.rodo')}
      </div>
    </div>
  );
};

CV.propTypes = {
  onPageChange: PropTypes.func,
};

CV.defaultProps = {
  onPageChange: undefined,
};

export default CV;
